const BettingCompanies = {
	Plural: 'Betting Companies',
	Single: 'Betting Company',
	DefaultSorting: 'Name',
	DefaultSortingType: 'asc',
	Columns: [
		{
			name: '',
			label: '#',
			type: 'counter',
		},
		{
			name: 'id',
			dbName: 'id',
			label: 'ID',
			sortable: true,
			required: true,
			type: 'text',
		},
		{
			name: 'name',
			dbName: 'Name',
			label: 'Name',
			sortable: true,
			required: true,
			type: 'text',
		},
		{
			name: 'url',
			dbName: 'Url',
			label: 'Url',
			sortable: true,
			type: 'text',
		},
		{
			name: 'countries',
			label: 'Countries',
			type: 'text',
			format: (item) => {
				const countries = item.countries || item.Countries || [];
				if (Array.isArray(countries) && countries.length) {
					return countries
						.map((country) => `<div>${country?.name ?? ''}</div>`)
						.join('');
				}
				const name = item.countryName || item.country?.name || '';
				return name ? `<div>${name}</div>` : '';
			},
		},
		{
			name: 'excludeCountries',
			label: 'Excluded Countries',
			type: 'text',
			format: (item) => {
				const countries = item.excludeCountries || item.ExcludeCountries || [];
				if (Array.isArray(countries) && countries.length) {
					return countries
						.map((country) => `<div>${country?.name ?? ''}</div>`)
						.join('');
				}
				const name = item.countryName || item.country?.name || '';
				return name ? `<div>${name}</div>` : '';
			},
		},
	],
	PrimaryKey: 'id',
	Actions: {
		addLink: '/betting-companies/add',
		editLink: '/betting-companies/edit/',
		deleteLink: true,
	},
};

export default BettingCompanies;
